import { useEffect } from 'react';

import type { Rive } from '@rive-app/react-canvas';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../stores/useStores';
import { formatValueWithKFloor } from '../../utils/helpers';

export const RIVE_BINGO_GC_PRIZE_KEY = 'prize_amount_cc';
export const RIVE_BINGO_CASH_PRIZE_KEY = 'prize_amount_sc';

interface UseRiveBingoPrizeUpdaterProps {
  rive?: Rive | null;
}

export const useRiveBingoPrizeUpdater = ({ rive }: UseRiveBingoPrizeUpdaterProps) => {
  const { bingoStore } = useStores();
  const { t } = useTranslation();

  const gcPrize = bingoStore.nextCasualBingoEvent?.game?.fullHousePrizePool;
  const cashPrize = bingoStore.nextSweepBingoEvent?.game?.fullHousePrizePool;

  useEffect(() => {
    if (!rive) {
      return;
    }

    try {
      if (gcPrize) {
        const gcValue = formatValueWithKFloor(gcPrize, t);
        rive.setTextRunValue(RIVE_BINGO_GC_PRIZE_KEY, gcValue);
      }
    } catch (error) {
      console.warn('Failed to set GC prize text in Rive:', error);
    }

    try {
      if (cashPrize) {
        const cashValue = `$ ${cashPrize.toLocaleString()}`;
        rive.setTextRunValue(RIVE_BINGO_CASH_PRIZE_KEY, cashValue);
      }
    } catch (error) {
      console.warn('Failed to set Cash prize text in Rive:', error);
    }
  }, [rive, gcPrize, cashPrize, t]);
};
